import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, Inject, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { DialogPanelComponentContent } from '@toro/common/shared/models/dialogs/DialogPanelComponentContent';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { filter } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-success-dialog',
  templateUrl: './success-dialog.component.html',
  styleUrls: ['./success-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SuccessDialogComponent extends DialogPanelComponentContent {

  public userEmail: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    @Inject(DOCUMENT) private document: Document,
    public elementRef: ElementRef,
    private store: Store<AppState>,
    private dialogReference: MatDialogRef<SuccessDialogComponent>,
    private router: Router
  ) {
    super(elementRef, true);
    this.document.body.classList.add('freeze');
    this.initUserProfileListener();
  }

  public initUserProfileListener = () => {
    this.store
      .select((user) => user.userProfile.user)
      .pipe( 
        filter((user) => !!user && !!user.email)
      )
      .subscribe((user) => {
        this.userEmail = this.hideEmail(user.email);
      })
  }

  public hideEmail(email: string) {
    const regex = new RegExp(/\B\w\B/gm);
    const mail = email.split('@');
    return mail[0].replace(regex, '*') + '@' + mail[1];
  }

  /**
     * Encerra componente, habilita overflow e destroi dialogReference
     */
  public closeDialog() {
    this.document.body.classList.remove('freeze');
    this.close(this.dialogReference, null);
    this.dialogReference = null;
  }

}
